import { atom } from "jotai";

export const appSettingAtom = atom({
  claimStates: [],
  // weitere Einstellungen hier ergänzen
});
